import { required } from 'vuelidate/lib/validators'

export const validateData = {
  form: {
    departament_id: { required },
  },
}

export const validateComputed = {
  DepartamentoIdErrors() {
    const errors = []
    if (!this.$v.form.departament_id.$dirty) return errors
    !this.$v.form.departament_id.required && errors.push('Departamento é obrigatório.')
    return errors
  },
}